export default {
  titulo: "Certifications",
  nueva: "New certification",
  editar: "Edit certification",
  eliminar: "Delete certification",
  pregEliminar: "Are you sure you want to delete the certification?",
  estados: {
    "Pendiente": "Pending",
    "En trámite": "In process",
    "Aprobado": "Approved"
  },
  fechaVto: "Expiration date",
  observaciones: "Observations"
}
